import React from "react";

const INPUT = "border-2 border-black bg-white px-2 py-1 text-xs w-full";

// One missing answer the admin can fill in (text, date or a pick-list).
export function FixInput({ field, spec, value, onChange, testId }) {
  if (spec.kind === "choice") {
    return (
      <select className={INPUT} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
        <option value="">Pick…</option>
        {spec.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  }
  return (
    <input className={INPUT} type={spec.kind === "date" ? "date" : field === "phone" ? "tel" : "text"} maxLength={80}
           value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
           max={spec.kind === "date" ? new Date().toISOString().slice(0, 10) : undefined} />
  );
}
